"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var ride_hailing_const_1 = require("./ride-hailing.const");
/**
 * RideHailingService
 * @class
 */
var RideHailingService = /** @class */ (function () {
    function RideHailingService() {
    }
    /**
     * Returns booking data
     * @returns `any`
     */
    RideHailingService.prototype.postCreateBooking = function (param) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.postCreateBooking;
        return axios_client_service_1.axiosClientInstance.post(url, param);
    };
    /**
     * Returns vehicle categoriees
     * @returns `any`
     */
    RideHailingService.prototype.getVehicleCategories = function (data) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.getVehicleCategories;
        return axios_client_service_1.axiosClientInstance.get(url, data);
    };
    /**
     * Returns booking detail
     * @returns `any`
     */
    RideHailingService.prototype.getDetailBooking = function (bookingUuid) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.getDetailBooking.replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Returns booking and chauffeur detail
     * @returns `{}`
     */
    RideHailingService.prototype.getBookingAndChauffeurDetails = function (bookingUuid) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.getBookingAndChauffeurDetails.replace('{{bookingUuid}}', bookingUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Cancels an active booking
     * @returns `any`
     */
    RideHailingService.prototype.cancelBooking = function (param) {
        var bookingId = param.bookingId;
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.cancelBooking.replace('{{bookingId}}', bookingId);
        return axios_client_service_1.axiosClientInstance.patch(url, param);
    };
    /**
     * Updates enabled tarrifs
     * @returns `any`
     */
    RideHailingService.prototype.patchEnableVehicleCategories = function (param) {
        var companyUuid = param.companyUuid;
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.patchEnableVehicleCategories.replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, param.data);
    };
    /**
     * Returns Vehicle categories
     * @returns `{}`
     */
    RideHailingService.prototype.getCompanyVehicleCategories = function (companyUuid) {
        var url = ride_hailing_const_1.RIDE_HAILING_ENDPOINT.getCompanyVehicleCategories.replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    return RideHailingService;
}());
/**
 * RideHailingService Class Instance
 * @namespace
 */
exports.rideHailing = new RideHailingService();
